﻿import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Card,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Typography
} from "@mui/material";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { FETCH_COMPANIES_TRADES } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import { BIGrey, BIRed } from "../../assets/helpers";
import SearchField from "../common/SearchField";
import AddCompanyWithRole from "../common/AddCompanyWithRole";
import { useDispatch } from "react-redux";
import { setShowReport } from "../../redux/actions/actions";
import { English } from "../../constant/EnglishFallback";
import InfiniteScroll from "react-infinite-scroll-component";
import Emptydata from "../common/Emptydata";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import Pages from "../../constant/ReportModel";

function TradeCompanySection({ id, scrollId }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginData, multiLanguageData, reportSuccess } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const ENGLISH = English.Trades || {};
  const LanguageData = multiLanguageData?.Trades || {};
  const {
    TEXT_NO_INFO_TRADE = ENGLISH.TEXT_NO_INFO_TRADE,
    TEXT_KONW_ANY_INFO = ENGLISH.TEXT_KONW_ANY_INFO,
    TEXT_ADD_COMPANY = ENGLISH.TEXT_ADD_COMPANY,
    TEXT_TRADE_COMPANIES_DESC = ENGLISH.TEXT_TRADE_COMPANIES_DESC,
    TEXT_NO_RESULTS_FOUND = ENGLISH.TEXT_NO_RESULTS_FOUND,
    BUTTON_REPORT = ENGLISH.BUTTON_REPORT,
    TEXT_ADD_COMPANY_TO_TRADE = ENGLISH.TEXT_ADD_COMPANY_TO_TRADE,
    TEXT_SEARCH_TRADE_COMPANIES = ENGLISH.TEXT_SEARCH_TRADE_COMPANIES
  } = LanguageData;
  const debounceTimeout = useRef(null);
  const [companyData, setCompanyData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearchLoader, setShowSearchLaoder] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [showAddCompanyModal, setShowAddCompanyModal] = useState(false);
  const [trade, setTrade] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);

  useEffect(() => {
    if (reportSuccess !== true) getInitialData();
  }, [reportSuccess]);

  const getInitialData = async () => {
    setIsLoading(true);
    await getCompanyData(searchTerm, 1, "fristTimeApiCall");
    setIsLoading(false);
  };

  const getCompanyData = async (searchTerm, pageNumber, fristTimeApiCall) => {
    try {
      setAllDataLoaded(false);
      const obj = {
        PageNr: pageNumber,
        NrOfRecPerPage: 20,
        FullSearch: searchTerm ?? "",
        SearchList: [{ TradeId: id }],
        userId: currentUserId,
        IncludeRecordNr: true,
        SortList: [{ FieldName: "CompanyName", Direction: "ASC" }],
        FetchAllowedRecordsOnly: true,
        TypeOfObjectReturned: ""
      };
      const res = await Postrequestcall(FETCH_COMPANIES_TRADES, obj, loginData?.accessToken);
      let resData =
        res?.data?.data?.sort((a, b) => a?.companyName?.localeCompare(b?.companyName)) ?? [];
      if (pageNumber > 1) {
        setTimeout(() => {
          setCompanyData((prevProducts) => [...prevProducts, ...resData]);
        }, 500);
      } else {
        setCompanyData(() => resData); // Set hasData for the first time API call
        if (fristTimeApiCall) {
          setHasData(resData?.length > 0);
        }
      }
    } catch (error) {
      console.log("getCompanyData-> Error While Getting Company Trade: ", error);
    } finally {
      setShowSearchLaoder(false);
      setIsLoading(false);
      setAllDataLoaded(false);
    }
  };

  const handleOpenReportModal = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      name: Pages?.tradesCompanies?.name,
      AppScreenId: Pages?.tradesCompanies?.id,
      recordId: trade.companyId ?? 0
    };
    dispatch(setShowReport(reportObj));
  };

  const onAddCompanyClick = () => {
    setShowAddCompanyModal(true);
  };

  const onItemClick = (item) => {
    navigate(`/company/${item?.companyId}`);
  };

  const onTradeClick = (currentTarget, trade) => {
    setTrade(trade);
    setMoreMenuAnchorEl(currentTarget);
  };

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  const NoInformation = () => {
    return (
      <Stack  sx={{ gap: 1, height: "100%" }}>
        <Button variant="text" sx={{ alignSelf: "flex-end" }} onClick={onAddCompanyClick}>
          {TEXT_ADD_COMPANY}
        </Button>
        <Box className="empty-data-card">
          <Emptydata
            icon={<BusinessCenterIcon className="emptydata-icon" />}
            firstText={TEXT_NO_INFO_TRADE}
            secondText={TEXT_KONW_ANY_INFO}
          />
        </Box>
      </Stack>
    );
  };

  const renderListing = () => {
    return (
      <Stack sx={{ gap: 1 }} >
        <Typography variant="body1" sx={{ color: "text.secondary" }}>
          {TEXT_TRADE_COMPANIES_DESC}
        </Typography>
        <SearchField
          placeholder={TEXT_SEARCH_TRADE_COMPANIES}
          value={searchTerm}
          onChange={(value) => {
            setShowSearchLaoder(true);
            const searchValue = value;
            setSearchTerm(searchValue);
            if (debounceTimeout.current) {
              clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
              getCompanyData(value, 1);
            }, 1000);
          }}
          onSubmit={() => {
            setShowSearchLaoder(true);
            setShowSearchLaoder(searchTerm);
            getCompanyData(searchTerm, 1);
          }}
          size={"small"}
        />
        <Button variant="text" sx={{ alignSelf: "flex-end" }} onClick={onAddCompanyClick}>
          {TEXT_ADD_COMPANY}
        </Button>
        <Stack spacing={1}>
          {showSearchLoader ? (
            <Stack style={{ padding: "30px" }}>
              <Loader />
            </Stack>
          ) : companyData?.length > 0 ? (
            <>
              <InfiniteScroll
                dataLength={companyData?.length}
                next={async () => {
                  increaseOffset((pageNumber) => {
                    getCompanyData(searchTerm, pageNumber);
                  });
                }}
                hasMore={true}
                loader={
                  !allDataLoaded ? null : (
                    <h4 style={{ display: "flex", justifyContent: "center" }}>
                      <Loader />
                    </h4>
                  )
                }
                scrollableTarget={scrollId}>
                <List disablePadding>
                  <Stack sx={{ gap: 1 }} >
                    {companyData.map((item) => (
                      <Card key={item?.id} className="pagelist-content">
                        <ListItem
                          key={item?.id}
                          style={{ padding: "0px" }}
                          secondaryAction={
                            <IconButton
                              onClick={(event) => onTradeClick(event.currentTarget, item)}>
                              <MoreIcon />
                            </IconButton>
                          }>
                          <ListItemButton
                            onClick={() => {
                              onItemClick(item);
                            }}>
                            <ListItemText primary={item?.companyName} />
                          </ListItemButton>
                        </ListItem>
                      </Card>
                    ))}
                  </Stack>
                </List>
                <Menu
                  anchorEl={moreMenuAnchorEl}
                  open={Boolean(moreMenuAnchorEl)}
                  onClose={() => setMoreMenuAnchorEl(null)}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}>
                  <MenuItem onClick={() => handleOpenReportModal()} style={{ color: BIRed }} dense>
                    {BUTTON_REPORT}
                  </MenuItem>
                </Menu>
              </InfiniteScroll>
            </>
          ) : (
            <Stack sx={{ justifyContent: "center", alignItems: "center" }} direction={"row"} style={{ color: BIGrey, padding: "30px" }}>
              {TEXT_NO_RESULTS_FOUND}
            </Stack>
          )}
        </Stack>
      </Stack>
    );
  };

  return (
    <Box className="main-content-card-list">
      <Card className="pagelist-content" sx={{ p: 2 }}>
        {isLoading ? <Loader /> : hasData ? renderListing() : <NoInformation />}
        {showAddCompanyModal && (
          <AddCompanyWithRole
            open={showAddCompanyModal}
            onClose={() => {
              setShowAddCompanyModal(false);
            }}
            title={TEXT_ADD_COMPANY_TO_TRADE}
            mainId={id}
            from={"trade"}
            onDataSave={async () => {
              setShowAddCompanyModal(false);
              await getInitialData();
            }}
          />
        )}
      </Card>
    </Box>
  );
}

export default TradeCompanySection;

